import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

@JsonObject()
export class GeneralRowSettings {
    @JsonProperty("rowWidthType")
    rowWidthType: string;

    @JsonProperty("rowWidthValue")
    rowWidthValue: string;

    @JsonProperty("marginTop")
    marginTop: string;

    @JsonProperty("marginBottom")
    marginBottom: string;

    @JsonProperty("paddingTop")
    paddingTop: string;

    @JsonProperty("paddingBottom")
    paddingBottom: string;

    @JsonProperty("paddingLeft")
    paddingLeft: string;

    @JsonProperty("paddingRight")
    paddingRight: string;

    @JsonProperty("backgroundColor")
    backgroundColor: string;

    @JsonProperty("backgroundImage")
    backgroundImage?: string;

    @JsonProperty("backgroundPosition")
    backgroundPosition?: string;
}

@JsonObject()
export class Responsiveness {
    @JsonProperty("lg")
    lg: number;

    @JsonProperty("md")
    md: number;

    @JsonProperty("sm")
    sm: number;

    @JsonProperty("xs")
    xs: number;
}

@JsonObject()
export class Positioning {
    @JsonProperty("direction")
    direction: "horizontal" | "vertical";

    @JsonProperty("alignment")
    alignment: "left" | "right" | "center" | "top" | "middle" | "bottom";
}

@JsonObject()
export class PageRowSettings {
    @JsonProperty("layout")
    layout: string;

    @JsonProperty("general")
    general: GeneralRowSettings;

    @JsonProperty("responsiveness")
    @JsonElementType(Responsiveness)
    responsiveness: Array<Responsiveness> = [];

    @JsonProperty("positioning")
    @JsonElementType(Positioning)
    positioning: Array<Positioning> = [];
}
